export const queueTaskInBackground =
  (globalThis.requestIdleCallback as typeof globalThis.requestIdleCallback | undefined) ||
  globalThis.setTimeout;
